import dayjs from "../../../utils/dayjs";

export const initstartDate = dayjs()
  .hour(13)
  .minute(0)
  .format();
export const initendDate = dayjs()
  .hour(15)
  .minute(0)
  .format();
export const initialStatePrestation = {
  prestation: {
    category: [],
    bill: null,
    isFollow: false,
    isSequentialPrestation: false,
    steps: {
      details: false,
      complements: false,
      searchInterpretes: false,
      resume: false,
      facturation: false,
    },
    name: "",
    selector: null,
    archived: false,
    interpretesStatus: [],
    intervention: {
      startDate: initstartDate,
      endDate: initendDate,
      location: "",
      phone: "",
      linkVisio: "",
      extra: "",
      type: "",
      requestedBy: "",
    },
    billing: null,
    applicationAt: null,
    applicant: null,
    beneficiary: {
      reference: "",
      firstname: "",
      lastname: "",
    },
    interventionFinal: {
      endDate: null,
      finishAt: null,
      location: null,
      note: "",
      name: "",
      signing: "",
      phone: "",
      email: "",
      startDate: null,
    },

    intervenant: null,
    status: "draft",
    interprete: null,
    search: {
      searchQualification: ["licence", "certificate", "none"],
      searchLevel: ["expert", "intermediate", "standard"],
      searchGenre: ["female", "male"],
    },
    languages: [],
    type: "",
    comment: {
      internal: "",
      interprete: "",
    },
    subject: "",
    reference: "",
    changes: {},
    institution: undefined,
    cancel: {
      cancelAt: null, // not accepted changes or cancel by admin
      cancelBy: null,
      cancelNote: "",
      applicantNotified: false,
      interpreteNotified: false,
    },
  },
  interpretes: [],
  cost: null,
  dangerousUpdate: false,
  ready: false,
  loading: false,
  loadingAppel: false,
  loadingEdit: false,
  interpretesHasSearch: false,
  loadingAnswer: false,
};
